import { useEffect } from "react";
import { useSetLanguage } from "../misc/utils";
import { useTranslation } from "react-i18next";
import "./NavBar.scss";
import { Button } from "@mui/material";
const NavBar = () => {
  const { t, i18n } = useTranslation();
  const lan = useSetLanguage();
  const language = lan.getLanguage();

  useEffect(() => {
    setTimeout(() => i18n.changeLanguage(language), 100);
  }, [language, i18n]);

  function handleClick(lang) {
    if (language === lang) {
      lang = ""; // Set to an empty string if the same language is clicked again
    }
    i18n.changeLanguage(lang);
    lan.setLanguage(lang);
  }

  return (
    <div className={`nav-bar`}>
      <img
        className="nav-bar-l  "
        src="/EP_logo_withwords-02.png"
        alt="pause-and-breathe-logo"
      />
      <Button
        variant="text"
        onClick={() => handleClick(language === "en" ? "" : "en")}
        className={`toggle-btn ${language === "en" ? "active" : "outline"}`}
        style={{
          color: language === "en" ? "#FFFFFF" : "#FFFFFF",
        }}
      >
        ENG
      </Button>
      <Button
        variant="text"
        onClick={() => handleClick(language === "zh" ? "" : "zh")}
        className={`toggle-btn ${language === "zh" ? "active" : "outline"}`}
        style={{
          color: language === "zh" ? "#FFFFFF" : "#FFFFFF",
        }}
      >
        中文
      </Button>
    </div>
  );
};

export default NavBar;
